export default "__VITE_ASSET__18uS6MYx__"